import { AdvisorSentiment } from "@types";

import { cn } from "./cn";

type BadgeVariant = "success" | "muted" | "warning" | "critical" | "info";

const VARIANT_STYLES: Record<BadgeVariant, string> = {
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  muted: "bg-gray-100 text-gray-600 border-gray-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  critical: "bg-red-50 text-red-700 border-red-200",
  info: "bg-sky-50 text-sky-700 border-sky-200",
};

export const SENTIMENT_BADGE_VARIANT: Record<AdvisorSentiment, BadgeVariant> = {
  positive: "success",
  neutral: "muted",
  warning: "warning",
  critical: "critical",
  info: "info",
};

export function Badge({
  variant = "muted",
  children,
  className,
}: {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        VARIANT_STYLES[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
